export default __webpack_public_path__ + "static/media/resp-rate-result.96302760.svg";